<script>
  import Vue from 'vue'
  import template from '@/components/views/template'
  Vue.use(window.VueAwesomeSwiper)

  export default {
    name: 'index',
    components: {
    },
    filters: {
    },
    mixins: [template],
    props: {

    },
    data() {
      return {
        swiperOption: {
          autoplay: {
            delay: 5000,
            disableOnInteraction: false
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          simulateTouch: false
        }
      }
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.swiper
      }
    },
    watch: {

    },
    created() {

    },
    mounted() {

    },
    methods: {

    }
  }
</script>

<template>
  <div class="container-wrap">
    <navigation></navigation>
    <div class="main-center cl">
      <div class="swiper-center">
        <swiper ref="mySwiper"
          :options="swiperOption">
          <swiper-slide>
            <div class="bxs-swiper-content">
              <img src="//media.winbaoxian.com/autoUpload/common/b1_04b92134ab7481d.jpg">
            </div>
          </swiper-slide>
          <!--<div class="swiper-pagination" slot="pagination"></div>-->
        </swiper>
      </div>
    </div>
    <div class="main-center">
      <div class="main-container">
        <article id="wyjj" class="weiease-introduction anchor-title">
          <div class="hd">
            <h3>安途简介</h3>
            <p><span>ANTU INTRODUCTION</span></p>
          </div>
          <div class="bd">
            <div class="content">
              <p>安途保险代理（广东）有限公司（以下简称安途保险代理），于2008年11月25日注册成立，注册资本金5000万元。</p>
              <p style="margin-bottom: 10px;">公司秉承着诚信合规，实事求是，客户至上，服务至上的宗旨，
                专注于提升保险从业人员的社会尊严、专业实力和服务效率，打造专业化保险方案定制专家；</p>
              <p>同时致力于推广客户需求导向化和方案定制化的服务模式，让每个客户享受到有温度、个性化的风险保障和资产配置等服务。</p>
            </div>
            <ul class="introduction-list cf">
              <li><img src="//img.winbaoxian.com/autoUpload/insurance/p2_ad9bba356dcad9f.png" alt="1"></li>
              <li><img src="//img.winbaoxian.com/autoUpload/insurance/p4_6a3f0cdb7b4f01e.png" alt="2"></li>
              <li><img src="//img.winbaoxian.com/autoUpload/insurance/p3_6b8351e659cd63a.png" alt="3"></li>
            </ul>
          </div>
        </article>
      </div>
    </div>
    <nav-footer class="main-center"></nav-footer>
  </div>
</template>

<style>
  @import 'reset';
  @import 'base';
  @import 'layout';
  @import 'variable';
  @import './index';

  .weiease-introduction {
    padding-top: 80px;
    padding-bottom: 80px;
    .hd {
      margin-bottom: 55px;
      span {
        background-color: #fff;
      }
    }
    .bd {
      .content {
        margin-bottom: 40px;
        text-align: center;
        line-height: 2;
      }
    }
  }

  .introduction-list {
    margin-right: -40px;
    li {
      float: left;
      width: 381px;
      height: 208px;
      margin-right: 30px;
    }
  }
</style>
